import type { TOC } from '@ember/component/template-only'
import { PopoverTooltipComponent } from '@blakeelearning/popovers/components/popover/tooltip'
import type { SafeString } from '@ember/template'

interface TooltipSignature {
  Element: HTMLElement
  Args: {
    text?: string | SafeString
    showOnRender?: boolean
  }
  Blocks: {
    default: []
  }
}

/*
 * w-max is necessary, else you can get very rare occurences of ResizeObserver errors, that may not replicate locally
 *
 * https://github.com/floating-ui/floating-ui/issues/1740#issuecomment-1563544849
 * https://github.com/floating-ui/floating-ui/issues/2338
 *
 * It may not be necessary if our implementation of tooltips swap from "layout" (top/left) positioning to "transform"
 * positioning.
 */
const classNames = 'w-max max-w-60 rounded-sm shadow-lg bg-neutral-400 px-3 py-2 text-center text-sm font-medium'

/**
 * Reexport the addon tooltip but with TUI's style
 */
export const Tooltip: TOC<TooltipSignature> = <template>
  {{#if @text}}
    <PopoverTooltipComponent
      data-test-tooltip
      class={{classNames}}
      @text={{@text}}
      @showArrow={{false}}
      @showOnRender={{@showOnRender}}
      ...attributes
    />
  {{/if}}
</template>

export default Tooltip
